import React, { useEffect, useState } from "react";
import { concat, has } from "ramda";

import OtherActions from "./OtherActions";

const CollectionOtherActions = React.forwardRef((props, ref) => {
  const { collection, removeFromParent } = props;

  const [ancestors, setAncestors] = useState([]);
  useEffect(() => {
    const ancestors = has("anthology", collection)
      ? concat([collection.anthology], collection.parentModules)
      : collection.parentModules;
    setAncestors(ancestors);
  }, [collection]);

  const handleRemoveClick = collection => event => {
    event.stopPropagation();
    event.preventDefault();
    removeFromParent(collection);
  };

  return (
    <OtherActions
      child={collection}
      ancestors={ancestors}
      handleRemoveClick={handleRemoveClick(collection)}
    />
  );
});

export default CollectionOtherActions;
